{
    "rapormusterigecici": {
        "Baslik": "Müşteri Geçici Yetki Raporu",
        "Kullanici": "Kullanıcı",
        "KullaniciGecici": "Kullanıcı Geçici",
        "AdSoyad": "Ad Soyad",
        "Cep": "Cep",
        "Referans": "Referans",
        "ID": "ID",
        "Takim": "Takım",
        "Sube": "Şube",
        "Ara": "Ara",
        "Temizle": "Temizle",
        "Filtrele": "Filtrele",
        "Sil": "Sil",
        "Sayfada": "Sayfada",
        "Olusturma": "Oluşturma",
        "Islem": "İşlem",
        "R": "R",
        "S": "S",
        "O": "O",
        "I": "İ",
        "C": "C",
        "R_Tooltip": "Randevu Adeti",
        "S_Tooltip": "Onaylı Satış",
        "O_Tooltip": "Bekleyen Satış",
        "I_Tooltip": "İptal Satış",
        "C_Tooltip": "Cayma Satış",
        "SilmeOnayMesaj": "Bu geçici yetkiyi kaldırmak istediğinize emin misiniz?",
        "SilmeBasarisiz": "Silme işlemi başarısız",
        "YetkinizYok": "Yetkiniz yok.",
        "YetkiKaldirildi": "Geçici yetki kaldırıldı.",
        "Kapat": "Kapat"
    }
}
